import {createAction} from 'redux-actions'
import {LOGGED_IN_USER_UPDATE} from './actionTypes'

export const updateLoggedInUser = createAction(LOGGED_IN_USER_UPDATE)



// WEBPACK FOOTER //
// ./web/js/loggedInUser/actions.js